import { FadeIn } from './fade-in';
import { HlsVideo } from './hls-video';

import { cn } from '~/lib/utils';


interface ProductHeroSectionProps {
  subtitle: string;
  title: string;
  videoSrc: string;
  fallbackVideoSrc: string;
  videoAriaLabel?: string;
  poster?: string;
  className?: string;
  subtitleClassName?: string;
  titleClassName?: string;
  videoWrapperClassName?: string;
  videoClassName?: string;
}

export const ProductHeroSection = ({
  subtitle,
  title,
  videoSrc,
  fallbackVideoSrc,
  videoAriaLabel = 'Background video',
  poster,
  className,
  subtitleClassName,
  titleClassName,
  videoWrapperClassName,
  videoClassName,
}: ProductHeroSectionProps) => {
  return (
    <section
      className={cn('relative w-full flex flex-col mt-[45px] md:mt-[85px]', className)}
    >
      <div className="w-full px-4 md:px-20 pt-10 pb-10 md:pt-[120px] md:pb-10 text-white bg-black">
        <FadeIn>
          <p
            className={cn(
              "font-['Fragment_Mono','Fragment_Mono_Fallback',monospace] text-sm tracking-[0.14px] uppercase",
              subtitleClassName
            )}
          >
            {subtitle}
          </p>
        </FadeIn>
        <FadeIn delay={0.15}>
          <p
            className={cn(
              "font-['Manrope','Manrope_Fallback',sans-serif] font-medium text-2xl tracking-[0.24px] capitalize",
              titleClassName
            )}
          >
            {title}
          </p>
        </FadeIn>
      </div>

      <div
        className={cn(
          'relative w-full aspect-[184/263] md:aspect-video',
          videoWrapperClassName
        )}
      >
        <HlsVideo
          src={videoSrc}
          fallbackSrc={fallbackVideoSrc}
          className={cn('w-full h-full object-cover', videoClassName)}
          playsInline
          loop
          muted
          autoPlay
          aria-label={videoAriaLabel}
          poster={poster}
        />
      </div>
    </section>
  );
};
